module.exports = __webpack_public_path__ + "img/charles2.55db57de.jpg";